import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import IconButton from "../IconButton/IconButton";
import { IconTwitter32, IconLinkedIn32, IconFacebook32, IconYouTube32 } from "../Icons/Icons";
import { Logo } from "../Logos/Logos";

import "./footer.scss";

const Footer = ({ className, children, ...props }) => {
  const classes = classnames("footer", className);

  return (
    <footer className={classes} {...props}>
      <section id="footer-top" className="footer-row footer-row--top">
        <div className="grid-container fluid">
          <div className="grid-x grid-margin-x">{children}</div>
        </div>
      </section>
      <section id="footer-middle" className="footer-row footer-row--bottom">
        <div className="grid-container fluid">
          <div className="grid-x grid-margin-x">
            <div className="footer-section cell">
              <div className="footer-logo">
                <a
                  href="https://www.accaglobal.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-logo__link"
                  title="Home Link"
                >
                  <Logo className="footer-logo__image" />
                </a>
              </div>
              <ul className="footer__social-links">
                <li className="footer__social-link">
                  <IconButton
                    icon={<IconLinkedIn32 />}
                    href="https://www.linkedin.com/school/162244"
                    newWindow
                    text="LinkedIn"
                  />
                </li>
                <li className="footer__social-link">
                  <IconButton
                    icon={<IconTwitter32 />}
                    href="https://twitter.com/ACCANews"
                    newWindow
                    text="Twitter"
                  />
                </li>
                <li className="footer__social-link">
                  <IconButton
                    icon={<IconYouTube32 />}
                    href="https://www.youtube.com/user/ACCAOfficial"
                    newWindow
                    text="YouTube"
                  />
                </li>
                <li className="footer__social-link">
                  <IconButton
                    icon={<IconFacebook32 />}
                    href="http://www.facebook.com/ACCA.Official"
                    newWindow
                    text="Facebook"
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </footer>
  );
};

Footer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
};
export default Footer;
